import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HideLoader, ShowLoader } from '@app/core/actions/loader';
import {
  HIDE_LOADER_HEADER,
  HIDE_LOADER_HEADER_VALUE,
  InterceptorHttpParams
} from '@app/core/interceptors/interceptor-http-params';
import * as fromRoot from '@app/reducer';
import { select, Store } from '@ngrx/store';
import { HttpMethod } from '@util/http-method';
import * as R from 'ramda';
import { Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

const getOperationName = R.path(['body', 'operationName']);

const getResponseStatus = R.path(['status']);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private isLoading$: Observable<boolean>;

  constructor(private store: Store<fromRoot.State>) {
    this.isLoading$ = this.store.pipe(select(fromRoot.getIsLoading));
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestParams = req.params;
    const interceptorConfig = requestParams instanceof InterceptorHttpParams ? requestParams.interceptorConfig : null;

    // GraphQL Apollo client passes http headers instead of params
    const headerHideLoader = req.headers.get(HIDE_LOADER_HEADER) === HIDE_LOADER_HEADER_VALUE;

    const shouldShowLoader = req.method === HttpMethod.POST &&
      !(interceptorConfig && interceptorConfig.hideLoader) && !headerHideLoader;

    const operationName = getOperationName(req);
    if (shouldShowLoader) {
      this.store.dispatch(new ShowLoader(operationName));
    }

    return next.handle(req).pipe(
      switchMap(res => this.handleSuccess(res, shouldShowLoader, operationName)),
      catchError(err => this.handleError(err, shouldShowLoader, operationName))
    );
  }

  handleSuccess(response: HttpEvent<any>, shouldShowLoader: boolean, op: any): Observable<HttpEvent<any>> {
    if (shouldShowLoader && getResponseStatus(response)) {
      this.store.dispatch(new HideLoader(op));
    }
    return of(response);
  }

  handleError(response: HttpEvent<any>, shouldShowLoader: boolean, op: any): Observable<HttpEvent<any>> {
    if (shouldShowLoader) {
      this.store.dispatch(new HideLoader(op));
    }
    return observableThrowError(response);
  }

}
